import React, {PropsWithChildren} from "react";
import {useSelector} from "react-redux";
import {getProject, getSport} from "modules/selectors";
import {HeaderNavLink} from "components/styled";

interface IProps {
	to: string;
	end?: boolean;
}

export const HeaderSportLink: React.FC<PropsWithChildren<IProps>> = ({to, end, children}) => {
	const sport = useSelector(getSport);
	const project = useSelector(getProject);

	const link = `/${project}/${sport}${to}`;
	return (
		<HeaderNavLink end={end} to={link}>
			{children}
		</HeaderNavLink>
	);
};
